export default {
    inject: ['lang'],
    methods: {
        translate(namespace, params = {}) {
            const lang = this.lang || window.lang;

            const translations = this.translations;
            if (!translations) {
                console.warn('Empty translations, add translations to the component!');
                return;
            }

            const ns = namespace.split('.');

            try {
                let translation = translations[ns[0]];

                for (let i = 1; i < ns.length; i++) {
                    translation = translation[ns[i]];
                }

                if (!translation[lang]) {
                    console.warn('No translation (%s) found for lang %s', namespace, lang);
                    return;
                }

                let result = translation[lang];

                if (typeof result === 'function') {
                    return result(params);
                }

                if (typeof result === 'string') {
                    return this.replacePlaceholders(result, params);
                }

                return result;
            } catch (e) {
                console.warn('No translation found for namespace %s using lang %s (%s)', namespace, lang, e);
            }
        },
        // shorthand
        t(namespace, params = {}) {
            return this.translate(namespace, params);
        },
        replacePlaceholders(translation, params) {
            // Replace placeholders like {phone}, {email}, etc., with actual values from params
            return translation.replace(/{(\w+)}/g, (placeholder, key) => {
                return params[key] !== undefined ? params[key] : placeholder;
            });
        },
    },
};
